<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="create"
      @updateSearch="(v) => (search = v)"
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :custom-filter="customFilter"
            :items="partnerBranches"
            fixed-header
            class="secondary row-height-50"
            :items-per-page="viewPartner ? itemsPerPage : 10"
            :hide-default-footer="viewPartner"
          >
            <template #[`item.action`]="{ item }">
              <v-icon
                :disabled="!item.active"
                small
                class="mr-2"
                color="accent"
                @click="edit(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.sub_partner_id`]="{ value }">
              {{ getSubPartner(value) }}
            </template>
            <template #[`item.partner_id`]="{ value }">
              {{ getPartner(value) }}
            </template>
            <template #[`item.email`]="{ value }">
              {{ value || "-" }}
            </template>
            <template #[`item.mobile_no`]="{ value }">
              {{ value || "-" }}
            </template>
            <template #[`item.whatsapp_mobile_no`]="{ value }">
              {{ value || "-" }}
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item) }}
              </v-chip>
            </template>
            <template
              v-if="
                viewPartner && partnerBranches.length > 5 && itemsPerPage > 0
              "
              v-slot:footer
            >
              <div class="d-flex text--accent justify-end mx-3 pa-3">
                <span
                  @click="navigate()"
                  style="
                    cursor: pointer;
                    color: #4f4584;
                    text-decoration: underline;
                  "
                  >View More</span
                >
              </div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createPartnerBranches"
        @update="updatePartnerBranches"
        @getSubPartners="getSubPartners"
        :partnerBranch="partnerBranch"
        :subPartners="subPartners"
        :partners="partners"
        :edit="editMode"
        :viewPartner="viewPartner"
        :viewSubPartner="viewSubPartner"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="branch"
      :name="currentItem.name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/partnerBranches/form.vue";
import searchBar from "@/components/searchBar.vue";
import { branchHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";

export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  props: {
    partnerId: {
      type: Number,
      default: () => 0,
    },
    subPartnerId: {
      type: Number,
      default: () => 0,
    },
    itemsPerPage: {
      type: Number,
      default: () => 0,
    },
    partners: {
      type: Array,
      default: () => [],
    },
    subPartners: {
      type: Array,
      default: () => [],
    },
    partnerBranches: {
      type: Array,
      default: () => [],
    },
    viewPartner: {
      type: Boolean,
      default: () => false,
    },
    viewSubPartner: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      partnerBranch: {},
      showDialog: false,
      currentItem: {},
      search: "",
      headers: branchHeaders,
    };
  },
  watch: {},
  computed: {},
  created() {
    if (this.viewSubPartner) {
      this.headers = this.headers.filter(
        (item) => item.value !== "sub_partner_id"
      );
    } else if (this.viewPartner) {
      this.headers = this.headers.filter((item) => item.value !== "partner_id");
    }
  },
  methods: {
    initialise() {
      if (this.viewSubPartner) {
        this.$emit("getpartnerBranchesBySubPartnerId");
      } else {
        this.$emit("getpartnerBranches");
      }
    },
    navigate() {
      this.$emit("viewMore", "Branches");
    },
    async createPartnerBranches(data) {
      await this.$axios
        .post("partner_branches", { partner_branch: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Partner branch created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updatePartnerBranches(data) {
      await this.$axios
        .put("partner_branches/" + data.id, { partner_branch: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Partner branch updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      this.updatePartnerBranches({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },
    showActiveStatus(item) {
      return item.active ? "Active" : "Inactive";
    },
    create() {
      this.partnerBranch = { partner_id: this.partnerId };
      if (this.subPartnerId)
        this.partnerBranch.sub_partner_id = this.subPartnerId;
      this.editMode = false;
      this.dialog = true;
    },
    edit(item) {
      this.partnerBranch = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.partnerBranch = {};
      this.currentItem = {};
    },
    getPartner(value) {
      return this.partners.find((partner) => partner.id == value)?.name;
    },
    getSubPartner(value) {
      return this.subPartners.find((partner) => partner.id == value)?.name;
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const sub_partner = this.getSubPartner(item.sub_partner_id);
      const status = this.showActiveStatus(item);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        status.toLowerCase().includes(search.toLowerCase()) ||
        sub_partner.toLowerCase().includes(search.toLowerCase())
      );
    },
    getSubPartners(partner_id) {
      this.$emit("getSubPartners", partner_id);
    },
  },
};
</script>

<style></style>
